import _app from '../../server';

let dashboard = {
  name: 'Dashboard',
  url: '/dashboard',
  icon: 'icon-speedometer'
};

let touring = {
  name: 'Touring',
  icon: 'icon-map',
  children
    : []
};
touring.children.push({
  name: 'Live',
  url: '/touring/live',
  icon: 'icon-globe'
});

if (_app.scheduler) {
  touring.children.push({
    name: 'Patrol Schedule',
    url: '/touring/schedule',
    icon: 'icon-clock'
  });
}
touring.children.push(
  {
    name: 'History',
    url: '/touring/history',
    icon: 'icon-clock'
  },
  {
    name: 'Statistics',
    url: '/touring/report',
    icon: 'icon-note'
  }
);

let panic = {
  name: 'Panic',
  icon: 'icon-energy',
  children: [
    {
      name: 'Ongoing',
      url: '/panic/ongoing',
      icon: 'icon-target'
    },
    {
      name: 'Resolved',
      url: '/panic/resolved',
      icon: 'icon-note'
    }
  ]
};
let summon = {
  name: 'Traffic',
  icon: 'icon-wallet',
  children: [
    {
      name: 'Issued',
      url: '/traffic/issued',
      icon: 'icon-login'
    },
    {
      name: 'Verified',
      url: '/traffic/verified',
      icon: 'icon-check'
    }
  ]
};

summon.children.push({
  name: 'Archived',
  url: '/traffic/archived',
  icon: 'icon-close'
});

let message = {
  name: 'Messages',
  icon: 'icon-envelope',
  children: [
    {
      name: 'Inbox',
      url: '/messages/inbox',
      icon: 'icon-envelope-letter'
    },
    {
      name: 'Trashed',
      url: '/messages/trashed',
      icon: 'icon-trash'
    }
  ]
};
let report = {
  name: 'Reports',
  icon: 'icon-fire',
  children: [
    {
      name: 'Active',
      url: '/reports/active',
      icon: 'icon-options'
    },
    {
      name: 'Archived',
      url: '/reports/archived',
      icon: 'icon-drawer'
    }
  ]
};



let axsesLink = {
  name: 'Axses',
  url: 'http://axses.utmsecurity.innates.my',
  icon: 'fa fa-external-link-square',
}
let barrierLink = {
  name: 'Barrier',
  url: 'http://barrier.utmsecurity.innates.my',
  icon: 'fa fa-external-link-square',
}
let droneLink = {
  name: 'Drones',
  url: 'http://jagadrone.utmsecurity.innates.my',
  icon: 'fa fa-external-link-square',
}


let items = [];

items.push(dashboard);
items.push(touring);
items.push(panic);
if (_app.summon) {
  items.push(summon);
}
if (_app.message) {
  items.push(message);
}

items.push(report);

items.push(axsesLink);
items.push(barrierLink);
items.push(droneLink);

export default {
  items: items
};



// WEBPACK FOOTER //
// ./src/components/config/_nav.js